import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Auth from '@aws-amplify/auth'
import { useSession, useAuthConfig } from './AuthProvider'

const Authenticate = () => {
  const location = useLocation()
  const authConfig = useAuthConfig()

  const redirectToKey = authConfig.afterAuthLocationCookieName
  const redirectToValue = `${location.pathname}${location.search}`
  window.localStorage.setItem(redirectToKey, redirectToValue)

  useEffect(() => {
    Auth.currentAuthenticatedUser().catch(() => {
      authConfig.onAuthNeededRedirection({
        Auth,
        federatedSignInParams: { customState: redirectToKey },
        location
      })
    })
  }, [authConfig, location, redirectToKey])

  return authConfig.LoadingAuthComponent
}

const PrivateRoute = ({
  element,
  allowedUserGroups,
  shouldShowStubbedPage = false,
  shouldCheckAuthentication = true
}) => {
  const { isAuthenticated, session } = useSession()
  const authConfig = useAuthConfig()
  const userGroups =
    session?.accessToken?.payload?.['cognito:groups']?.join(',') ||
    'defaultUserGroup'
  const userHasApplicationAccess =
    userGroups.match(allowedUserGroups || authConfig.allowedUserGroups)
      ?.length > 0

  const NotAuthorizedComponent = authConfig.NotAuthorizedComponent || (
    <div>Not allowed</div>
  )

  // return the Authenticate component if not authenticated
  if (!isAuthenticated) {
    return <Authenticate />
  }

  // return user no authorized component if user has no application access
  if (!userHasApplicationAccess) {
    return NotAuthorizedComponent
  }

  // return page
  return element
}

export default PrivateRoute
